"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.features = void 0;
exports.features = [
    'Google Search (cb_search_intent)',
    'Search & Message Bot (cb_message_search_only)',
    'Message (cb_message_intent)',
    'RASA (Machine learning model for FAQs)'
];
